import { redactSensitiveStringsInValue } from '../redactSensitiveStringsInValue/redactSensitiveStringsInValue.js';
import { shouldRedactKey } from '../shouldRedactKey/shouldRedactKey.js';

/**
 * Redacts values in a nested object based on the provided keys to redact.
 * @param obj - The object to redact values from.
 * @param keysToRedact - An array of strings or regular expressions representing the keys to redact.
 * @returns A new object with values redacted based on the provided keys.
 */ function redactObject(obj, keysToRedact) {
    // Base case: If the input is not an object or array, return it but redact sensitive values from it
    if (typeof obj !== 'object') {
        return redactSensitiveStringsInValue(obj, keysToRedact);
    }
    // If the input is an array, map over it and recursively redact each element
    if (Array.isArray(obj)) {
        return obj.map((item)=>redactObject(item, keysToRedact));
    }
    // Create a new object to store the redacted values
    const redactedObj = {};
    // Iterate over the keys of the input object
    for(const key in obj){
        // Check if the current key should be redacted
        if (shouldRedactKey(key, keysToRedact)) {
            // If the key should be redacted, assign the redacted value
            redactedObj[key] = '***REDACTED***';
        } else {
            // If the key should not be redacted, recursively redact the value
            redactedObj[key] = redactObject(obj[key], keysToRedact);
        }
    }
    return redactedObj;
}

export { redactObject };
//# sourceMappingURL=redactObject.js.map
